import type { ReactElement } from 'react';
import { PageHeader } from '@/shared/ui';
import { NotificationSettingsPanel } from '@/widgets/notification-settings-panel';

/** 알림 설정(/notifications/settings, 사이드바 '설정 > 알림 설정' — 알림 설계 §6-2) — 설정 위젯을 조합만 한다. */
export const NotificationSettingsPage = (): ReactElement => (
  <>
    <PageHeader
      title="알림 설정"
      description="알림 종류별 발송 여부와 운영자 알림을 받을 담당자를 정합니다. 바꾼 설정은 재배포 없이 다음 발송부터 적용됩니다."
    />
    <NotificationSettingsPanel />
  </>
);
